import React, { useState, useEffect } from 'react';
import {useHistory} from "react-router-dom";
import {useSelector} from "react-redux";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    makeStyles,
    Typography,
    FormControlLabel,
    Checkbox, Snackbar,
} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
import Alert from "@material-ui/lab/Alert";
import CircularProgress from "@material-ui/core/CircularProgress";

import { t } from './common/LocalizationProvider';
import EditItemView from './shared/EditItemView';
import EditAttributesView from './attributes/EditAttributesView';
import deviceAttributes from './attributes/deviceAttributes';
import SelectField from './form/SelectField';
import { deviceCategories } from './common/deviceCategories';
import LinkField from './form/LinkField';
import { prefixString } from './common/stringUtils';
import {formatDate} from "./common/formatter";
import {cyberStyles} from "./cssShared/cyberTheme";
import ConfirmHandler from "./shared/ConfirmHandler";

const useStyles = makeStyles(theme => ({
    ...cyberStyles(theme),
    loading: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: theme.spacing(2),
    },
}));

const DevicePage = () => {
    const classes = useStyles();
    const user = useSelector(state => state.session.user && state.session.user);
    const storedToken = localStorage.getItem('tokenThingwings');
    const history = useHistory();

    const [item, setItem] = useState();
    const [open, setOpen] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [msg, setmsg] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setItem((pervItem) => ({...pervItem, phone: user.phone}))
    },[user.phone])

    const handleOpen = () => { setOpen(true) };
    const handleCloseSnackbar = () => { setOpenSnackbar(false); };
    function handleDisable() { return false; }

    const handleEdit = async (itemId) => {
        setLoading(true)
        let url = `/api/devices/device/${itemId}`;
        try {
            const response = await fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Auth-Token': 'Bearer ' + storedToken,
                },
                body: JSON.stringify(item),
            });
            if (response) setLoading(false)
            if (response.ok) history.goBack();
            else if (response.status === 400){
                const errorText = await response.text();
                setmsg(t(errorText.split(' ')[0]))
                setOpenSnackbar(true)
            } else {
                setOpenSnackbar(true)
                setmsg(t('UnknownProblem'))
            }
        } catch (error) { throw error; }
    };

    const handleRemoveResult = () => {
        setOpen(false);
        history.goBack();
    }

    return (
        <EditItemView endpoint="devices" item={item} setItem={setItem}>
            {item &&
                <>
                    {(user.subadmin && item.id && (item.configured === "should_delete_C" || item.configured === "should_delete_N")) ? (
                        <>
                            <Accordion defaultExpanded className={classes.accordion}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon style={{ color: '#00f2ff' }} />}>
                                    <Typography className={classes.summaryText}>
                                        {t('confirmation')}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails className={classes.details} >
                                    <Typography  className={classes.summaryText}>
                                        {user.subadmin  ? (<>
                                            {t('deleteion_Confirmation')} <strong>{item.name}</strong>
                                        </>) : (<>
                                            {t('should_delete_C')}
                                        </>)}
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <div>
                                {loading && <div className={classes.loading}>
                                    <CircularProgress color="secondary" />
                                </div>}
                            </div>
                            <FormControl fullWidth margin="normal">
                                <div className={classes.buttons}>
                                    <Button
                                        type="button"
                                        variant="outlined"
                                        className={classes.cyberButtonSecondary}
                                        onClick={() => handleEdit(item.id)}
                                        disabled={handleDisable()}
                                    >
                                        {t('refuse')}
                                    </Button>
                                    <Button
                                        type="button"
                                        variant="outlined"
                                        className={`${classes.cyberButtonRemoveDialog} ${classes.saveButtonRemoveDialog}`}
                                        onClick={handleOpen}
                                        disabled={handleDisable()}
                                    >
                                        {t('Confirm')}
                                    </Button>
                                </div>
                            </FormControl>
                            <ConfirmHandler open={open} endpoint="devices" itemId={item.id} handleCloseDialog={handleRemoveResult}/>
                            <Snackbar open={openSnackbar} autoHideDuration={12000} onClose={handleCloseSnackbar} >
                                <Alert onClose={handleCloseSnackbar} variant="filled" severity="error">
                                    {msg}
                                </Alert>
                            </Snackbar>
                        </>
                    ) : (
                        <>
                            <Accordion defaultExpanded className={classes.accordion}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon style={{ color: '#00f2ff' }} />}>
                                    <Typography className={classes.summaryText}>
                                        {t('sharedRequired')}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails className={classes.details}>
                                    {item.id && item.configured !== "configured" &&
                                        <div className={classes.configue}>{t(item.configured)}</div>}
                                    <TextField
                                        className={classes.formControl}
                                        margin="normal"
                                        value={item.name || ''}
                                        onChange={event => setItem({...item, name: event.target.value})}
                                        label={t('sharedName')}
                                        variant="filled"
                                        required/>
                                    <TextField
                                        className={classes.formControl}
                                        margin="normal"
                                        value={item.uniqueId || ''}
                                        onChange={event => setItem({...item, uniqueId: event.target.value})}
                                        label={t('deviceIdentifier')}
                                        variant="filled"
                                        required/>
                                    <TextField
                                        className={classes.formControl}
                                        margin="normal"
                                        value={item.phone || (user.phone & user.phone)}
                                        onChange={event => setItem({...item, phone: event.target.value})}
                                        label={t('sharedPhone')}
                                        variant="filled"
                                        required/>
                                    <TextField
                                        className={`${classes.noDotsDisabled} ${classes.formControl}`}
                                        margin="normal"
                                        value={item?.expiredAt && formatDate(item.expiredAt, 'YYYY-MM-DD HH:mm')}
                                        onChange={event => setItem({...item, expiredAt: event.target.value})}
                                        label={t('userExpirationTime')}
                                        variant="filled"
                                        type="datetime-local"
                                        fullWidth
                                        disabled={!user.administrator ? true : false}
                                        InputLabelProps={{ shrink: true }}/>
                                </AccordionDetails>
                            </Accordion>
                            {item.configured === "configured" && (
                                <>
                                    <Accordion className={classes.accordion}>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon style={{ color: '#00f2ff' }} />}>
                                            <Typography className={classes.summaryText}>
                                                {t('sharedExtra')}
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails className={classes.details}>
                                                <SelectField
                                                    className={classes.neonInput}
                                                    margin="normal"
                                                    value={item.groupId || 0}
                                                    onChange={event => setItem({...item, groupId: Number(event.target.value)})}
                                                    endpoint="/api/groups"
                                                    label={t('groupParent')}
                                                    variant="filled"/>
                                                <TextField
                                                    className={classes.formControl}
                                                    margin="normal"
                                                    value={item.model || ''}
                                                    onChange={event => setItem({...item, model: event.target.value})}
                                                    label={t('deviceModel')}
                                                    variant="filled"
                                                    fullWidth/>
                                                <TextField
                                                    className={classes.formControl}
                                                    margin="normal"
                                                    value={item.contact || ''}
                                                    onChange={event => setItem({...item, contact: event.target.value})}
                                                    label={t('deviceContact')}
                                                    variant="filled"
                                                    fullWidth/>
                                                <SelectField
                                                    margin="normal"
                                                    value={item.category || 'default'}
                                                    emptyValue={null}
                                                    onChange={event => setItem({...item, category: event.target.value})}
                                                    data={deviceCategories.map(category => ({
                                                        id: category,
                                                        name: t(`category${category.replace(/^\w/, c => c.toUpperCase())}`)
                                                    }))}
                                                    label={t('sharedTypeCategory')}
                                                    variant="filled"/>
                                            {user.subadmin &&
                                                <FormControlLabel
                                                    className={classes.checkboxLabel}
                                                    control={<Checkbox
                                                        checked={item.disabled}
                                                        onChange={event => setItem({...item, disabled: event.target.checked}
                                                        )}
                                                    />
                                                }
                                                label={t('sharedDisabled')}/>
                                            }
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion className={classes.accordion}>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon style={{ color: '#00f2ff' }} />}>
                                            <Typography className={classes.summaryText}>
                                                {t('sharedAttributes')}
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails className={classes.details}>
                                            <EditAttributesView
                                                attributes={item.attributes}
                                                setAttributes={attributes => setItem({...item, attributes})}
                                                definitions={deviceAttributes}
                                            />
                                        </AccordionDetails>
                                    </Accordion>
                                    {item.id &&
                                        <Accordion className={classes.accordion}>
                                            <AccordionSummary expandIcon={<ExpandMoreIcon style={{ color: '#00f2ff' }} />}>
                                            <Typography className={classes.summaryText}>
                                                    {t('sharedConnections')}
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails className={`${classes.details} ${classes.linkFieldWrapper}`}>
                                                <LinkField
                                                    margin="normal"
                                                    endpointAll="/api/geofences"
                                                    endpointLinked={"/api/geofences?deviceId=" + item.id}
                                                    baseId={item.id}
                                                    keyBase="deviceId"
                                                    keyLink="geofenceId"
                                                    label={t('sharedGeofences')}
                                                    variant="filled"/>
                                                <LinkField
                                                    margin="normal"
                                                    endpointAll="/api/notifications"
                                                    endpointLinked={"/api/notifications?deviceId=" + item.id}
                                                    baseId={item.id}
                                                    keyBase="deviceId"
                                                    keyLink="notificationId"
                                                    titleGetter={it => t(prefixString('event', it.type))}
                                                    label={t('alerts')}
                                                    variant="filled"/>
                                                <LinkField
                                                    margin="normal"
                                                    endpointAll="/api/drivers"
                                                    endpointLinked={"/api/drivers?deviceId=" + item.id}
                                                    baseId={item.id}
                                                    keyBase="deviceId"
                                                    keyLink="driverId"
                                                    label={t('sharedDrivers')}
                                                    variant="filled"/>
                                                <LinkField
                                                    margin="normal"
                                                    endpointAll="/api/attributes/computed"
                                                    endpointLinked={"/api/attributes/computed?deviceId=" + item.id}
                                                    baseId={item.id}
                                                    keyBase="deviceId"
                                                    keyLink="attributeId"
                                                    titleGetter={it => it.description}
                                                    label={t('sharedComputedAttributes')}
                                                    variant="filled"/>
                                                <LinkField
                                                    margin="normal"
                                                    endpointAll="/api/maintenance"
                                                    endpointLinked={"/api/maintenance?deviceId=" + item.id}
                                                    baseId={item.id}
                                                    keyBase="deviceId"
                                                    keyLink="maintenanceId"
                                                    label={t('sharedMaintenance')}
                                                    variant="filled"/>
                                            </AccordionDetails>
                                        </Accordion>
                                    }
                                </>
                            )}
                        </>
                    )}
                </>
            }
        </EditItemView>
    );
}

export default DevicePage;